import React from 'react';

import format from 'date-fns/format';
import isToday from 'date-fns/isToday';
import isTomorrow from 'date-fns/isTomorrow';

import { Text } from '@r-client/shared/ui/core';

import styles from './week-day.module.scss';

export interface IWeekDayProps {
  date: string;
  today: string;
  tomorrow: string;
  className?: string;
}

export const WeekDay: React.FC<React.PropsWithChildren<IWeekDayProps>> = ({
  date,
  today,
  tomorrow,
  className,
}) => {
  let content: React.ReactElement | null = null;
  const dateInLocalTime = new Date(date);

  if (isToday(dateInLocalTime)) {
    content = (
      <Text as="span" weight="300" className={styles.highlight}>
        {today}
      </Text>
    );
  } else if (isTomorrow(dateInLocalTime)) {
    content = (
      <Text as="span" weight="300" className={styles.highlight}>
        {tomorrow}
      </Text>
    );
  } else {
    content = (
      <Text
        as="span"
        weight="300"
        color="gray80"
        data-testid="weekday"
        className={className}
      >
        {format(dateInLocalTime, 'EEEE')}
      </Text>
    );
  }

  return <span className={className}>{content}</span>;
};
